import { render, staticRenderFns } from "./ChooseStore.vue?vue&type=template&id=5ccc57be"
import script from "./ChooseStore.vue?vue&type=script&lang=js"
export * from "./ChooseStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports